module.exports = __webpack_public_path__ + "img/logo.4a44e66b.png";